export default function documentsFilter(element, data) {   
        // Находим все ссылки-фильтры
        const filterLinks = document.querySelectorAll('.categories .item');
        // Находим все элементы
        const documentsItems = document.querySelectorAll('.document__items .document__item');

        filterLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
    
                // Получаем выбранный город из data-атрибута
                const category = this.getAttribute('data-category');

                // Переключаем активный класс
                document.querySelector('.categories .item.active').classList.remove('active');
                this.classList.add('active');

                // Фильтруем
                documentsItems.forEach(item => {
                    const itemcategory = item.getAttribute('data-category_name');
                    if (category === 'Все' || itemcategory === category) {
                        item.style.display = '';
                    } else {
                        item.style.display = 'none';
                    }
                });
            });
        });
};